import React from "react";
import "./footer.css";
export default function Footer() {
  return (
    <div className="footer">
      <img src="/img/logo.png" width="32px" height="32px" alt="logo" />
      José Luis Sequeira Góngora&copy;
    </div>
  );
}
